import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import autocomplete, {AutocompleteResult} from "autocompleter/autocomplete";

import Fragment from "dce-fragments/lib/fragments/Fragment";
import findFragmentParent from "dce-fragments/lib/fragments/utils/findFragmentParent"
import DceWireEventDetails from "dce-fragments/lib/fragments/dceplugin/DceWireEventDetails"

interface AutocompleteFieldProps {
    wireAction: string;
}

interface SearchResult {
    label: string;
    type: string;
    wireClick: string;
    id:string;
    group: string;

    subtype: string;
    status: string;
    statusColor: string;
}

function el(className: string, inner: string){
    let div = document.createElement("div");
    div.innerHTML = inner;
    div.classList.add(className);
    return div;
}

function elWithSub(className: string, ...inner: Element[]){
    let div = document.createElement("div");
    div.append(...inner);
    div.classList.add(className);
    return div;
}

@Dce("SearchField")
export default class AutocompleteField extends DceComponent<AutocompleteFieldProps> {

    private input: HTMLInputElement;
    private container: HTMLDivElement;
    private parentFragment: Fragment;
    private ac: AutocompleteResult;

    constructor(elem: DceHTMLElement, props: AutocompleteFieldProps) {
        super(elem, props);

        //znalezienie parenta ktory jest fragmentem
        this.parentFragment = findFragmentParent(elem);

        console.log("PF", this.parentFragment);

        this.container = document.createElement('div');
        this.input = this.elem as unknown as HTMLInputElement

        this.input.addEventListener('change', (e) => {

            if(this.input.value){
                this.input.classList.add('active');
            }else{
                this.input.classList.remove('active');
            }

        });

        this.input.addEventListener('focus', (e) => {

            if(this.input.classList.contains('active')){
                if(this.container.children.length > 0){
                    this.container.style.display = "block";
                }
            }

        })

        this.ac = autocomplete<SearchResult>({
            preventSubmit: true,
            disableAutoSelect: true,
            minLength: 3,
            input: this.input,
            debounceWaitMs: 200,
            container: this.container,
            emptyMsg: "Brak wyników",
            fetch: async (text, update) => {
                text = text.toLowerCase();

                let resp = await this.parentFragment.call(
                    this.props.wireAction,
                    {
                        query: text
                    }
                )

                let d: SearchResult[] = [];

                if(resp.hasData("suggest")){
                    d = resp.data['suggest'];
                }

                update(d);
            },
            onSelect: item => {

                elem.dispatchEvent(new CustomEvent<DceWireEventDetails>("dceWire", {
                    bubbles: true,
                    detail: {
                        type: "click",
                        element: elem,
                        attr: item.wireClick,
                        originalEvent: null
                    }
                }));

                //alert(item.wireClick);
            },

            render: (item: SearchResult, currentValue: string): HTMLDivElement | undefined => {
                const itemElement = document.createElement("div");
                itemElement.className = "topbar--search-autocomplete-item";
                itemElement.innerHTML = item.label;

                if(item.subtype || item.status){
                    let meta = this.div("topbar--search-autocomplete-item-meta");

                    if(item.status){

                        let s = el("status", item.status);
                        s.style.setProperty("--color", item.statusColor);
                        meta.append(s);

                    }

                    if(item.subtype){
                        let s = el("subtype", item.subtype);
                        meta.append(s);
                    }

                    itemElement.append(meta);
                }


                return itemElement;
            }
        });

    }


    private div(cssClass: string): HTMLDivElement {
        let div = document.createElement("div");
        div.className = cssClass;
        return div;
    }

    onRemove() {
        if(this.ac){
            this.ac.destroy();
        }
    }
}
